import { getBaseUrlFromPiva, nsApi } from 'boot/axios'
import { MyStorage } from 'src/helpers/storage'

class InvalidTenant extends Error {
  constructor() {
    super()

    // // Maintains proper stack trace for where our error was thrown (only available on V8)
    // if (Error.captureStackTrace) {
    //   Error.captureStackTrace(this, InvalidTenant)
    // }

    this.name = 'InvalidTenant'
  }
}

// Minosse (sincronizzazione con Noah): stessa sessione del gestionale, sul dominio delle altre app
export const minosseUrl = `https://minosse.${process.env.DOMAIN}`

export default {
  namespaced: true,

  state: {
    piva: null,
    baseURL: null,
    apps: [],
  },

  getters: {
    url: ({ baseURL }) => {
      if (baseURL) return `https://${baseURL}.${process.env.URI}.${process.env.DOMAIN}/api`
      throw new InvalidTenant()
    },
    applications: (state, _, rootState) => [
      { value: 'analytics', label: 'Analytics', icon: 'mdi-monitor-dashboard', caption: 'Monitora i tuoi KPI' },
      { value: 'calendar', label: 'Calendar', icon: 'mdi-calendar-blank', caption: 'Agenda di tutti i collaboratori' },
      { value: 'mentore', label: 'Mentore', icon: 'mdi-face-agent', caption: 'Consigliere saggio e fidato', disable: !rootState.auth.user.crm_accesso },
      { value: 'minosse', label: 'Minosse', icon: 'mdi-ear-hearing', caption: 'Sincronizzazione con Noah' },
      { value: 'ai', label: 'AI', icon: 'mdi-auto-fix', caption: 'Parla con i tuoi dati', badge: 'Beta' },
    ].filter(a => state.apps.includes(a.value)),
  },

  actions: {
    async setApplications({ commit }, piva) {
      const { data: { applications, theme } } = await nsApi.post('check-active', { piva, app: process.env.URI })
      commit('SET_APPS', applications.map(a => a.app))
      commit('theme/update', theme, { root: true })
    },

    async init({ commit, state }) {
      MyStorage.has('piva') && commit('SET_KEY', { key: 'piva', value: MyStorage.get('piva') })
      MyStorage.has('baseURL') && commit('SET_KEY', { key: 'baseURL', value: MyStorage.get('baseURL') })
      // MyStorage.has('locale') && commit('SET_KEY', { key: 'locale', value: MyStorage.get('locale') })

      state.piva && !state.baseURL && commit('SET_KEY', { key: 'baseURL', value: await getBaseUrlFromPiva(state.piva) })
    },

    async setKeys({ commit }, { piva, baseURL, locale }) {
      piva !== undefined && commit('SET_KEY', { key: 'piva', value: piva })
      baseURL !== undefined && commit('SET_KEY', { key: 'baseURL', value: baseURL })
      locale !== undefined && commit('SET_KEY', { key: 'locale', value: locale })
    },
  },

  mutations: {
    SET_APPS(state, apps) { state.apps = apps },
    SET_KEY(state, { key, value }) {
      state[key] = value
      value === null
        ? MyStorage.remove(key)
        : MyStorage.set(key, value)
    },
  },
}
